import * as React from "react";
import * as _ from "lodash";
import { observer } from "mobx-react";
import {
  Table,
  TableRow,
  TableCell,
  withStyles,
  TextField,
  Typography,
  IconButton,
  Button,
} from "@material-ui/core";
import { Done, Search, AddCircle as Remove } from "@material-ui/icons";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import lupa from "common/assets/images/lupaTransparente.png";
import i18n from "i18n";
import { useEffect, useRef } from "react";
import { gtag } from "ga-gtag";

const TOP_HEADER = 113;
const styles = (theme) => ({
  editFormatBody: {
    height: "calc(100% - 122px)",
  },
  editFormatActions: {
    display: "flex",
    justifyContent: "center",
  },
  searchSection: {
    width: "30%",
    backgroundColor: "#F2F2F2",
    float: "left" as any,
    paddingRight: 5,
  },
  searchSectionTitle: {
    fontFamily: "Raleway",
    fontWeight: 700,
    color: "rgba(0, 0, 0, 0.64)",
    padding: "15px 44px 0px",
  },
  searchFormControl: {
    overflow: "hidden",
    position: "relative" as any,
  },
  searchInput: { marginLeft: 42, paddingRight: 52 },
  icon: {
    fontSize: 20,
    position: "absolute" as any,
    color: "rgba(0, 0, 0, 0.34)",
  },
  iconRemove: {
    right: 8,
    transform: "rotate(45deg)",
    marginRight: 6,
    cursor: "pointer",
    top: 22,
  },
  iconSearch: {
    marginLeft: 12,
    top: 25,
  },
  searchResultList: {
    width: "100%",
    fontFamily: "Roboto",
    color: "rgba(25, 25, 26, 1)",
    fontSize: "13px",
    height: "calc(100vh - (" + TOP_HEADER + "px + 56px + 37px + 122px))",
    overflowY: "scroll" as any,
  },
  searchNotFound: {
    display: "flex",
    alignItems: "center" as any,
    flexDirection: "column" as any,
    textAlign: "center" as any,
    paddingTop: "calc(10vh)",
  },
  searchNotFoundTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "#212121",
    marginBottom: "5px",
  },
  searchNotFoundSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "#5c5c5c",
    width: "68%",
  },
  editFormatHeader: {
    display: "flex",
    boxShadow: "-3px 0px 3px 0px rgba(0,0,0,0.16)",
  },
  headerTitleItems: {
    paddingLeft: "10px",
    width: "33%",
    margin: "10px 0 10px 0",
  },
  table: {
    float: "left" as any,
    height: "calc(100vh - " + TOP_HEADER + "px -  43px - 122px)",
    overflowY: "scroll" as any,
  },
  editFormatTable: {
    position: "relative" as any,
    width: "70%",
    boxShadow: "-3px 0px 3px 0px rgba(0,0,0,0.16)",
  },
  tableFont: {
    fontFamily: "Roboto",
  },
  tableBody: {
    fontSize: "13px",
    color: "#666",
    "& > :first-child": {
      borderTop: "1px solid #e0e0e0",
    },
  },
  rowRoot: {
    height: "25px",
    "& > :last-child": {
      padding: "0px",
      borderRight: "0",
    },
  },
  cellRoot: {
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
  },
  input: {
    outlineStyle: "none" as any,
    paddingRight: 10,
    paddingLeft: 15,
    fontSize: "13px",
    color: "#666",
    height: "24px",
    width: "100%",
    border: 0,
    backgroundColor: "unset",
  },
  button: {
    height: "36px",
    marginBottom: 50,
    marginTop: 36,
    marginLeft: 8,
    marginRight: 8,
  },
  buttonSave: {
    width: "84px",
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
  },
  buttonCancel: {
    width: "102px",
    background: "#ABABAB",
    "&:hover": {
      background: "#8f8f8f",
    },
  },
  checkField: {
    opacity: 0,
  },
  fieldPicker: {
    lineHeight: "44px" as any,
    paddingLeft: "44px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
    "&:hover button": {
      opacity: 1,
      float: "right" as any,
    },
  },
});

type IProps = {
  classes: any;
};

type RowsProps = {
  classes: any;
  line: any;
  index: number;
  onChangeInputRef: Function;
  onFocus: Function;
  onBlur: Function;
  paddingOffiset: number;
  readonly: boolean;
  isSelected: boolean;
  descHasError: boolean;
  qttHasError: boolean;
};

const TakeOffEditFormatRow = (props: RowsProps) => {
  const {
      classes,
      line,
      index,
      onFocus,
      onBlur,
      descHasError,
      qttHasError,
      isSelected,
      paddingOffiset,
      readonly,
      onChangeInputRef,
    } = props,
    cellClasses = { root: classes.cellRoot };
  const inputsDescRef: any = useRef(),
    inputsQttRef: any = useRef(),
    inputsUnitRef: any = useRef();

  useEffect(() => {
    if (inputsDescRef) {
      inputsDescRef.current.value = line.description;
    }
    if (inputsQttRef) {
      inputsQttRef.current.value = line.quantity;
    }
    if (inputsUnitRef) {
      inputsUnitRef.current.value = line.unit;
    }

    onChangeInputRef(index, [inputsDescRef]);
  }, [line.description, line.quantity, line.unit]);

  return (
    <TableRow
      classes={{ root: classes.rowRoot }}
      key={line.index}
      style={{
        backgroundColor: isSelected ? "rgba(237, 242, 203, 1)" : "unset",
      }}
    >
      <TableCell classes={cellClasses} key={line.index + "desc"}>
        <input
          ref={inputsDescRef}
          id={"input-desc-" + index}
          name={"description"}
          type="text"
          autoFocus={index === 0}
          className={classes.input}
          onFocus={onFocus(line, line.description)}
          onBlur={onBlur(line)}
          defaultValue={line.description}
          style={{
            paddingLeft: (paddingOffiset + 1) * 15,
            border: descHasError ? "1px dashed #f00" : "",
          }}
        />
      </TableCell>
      <TableCell classes={cellClasses} key={line.index + "qtt"}>
        <input
          ref={inputsQttRef}
          id={"input-qtt-" + index}
          name={"quantity"}
          type="text"
          readOnly={readonly}
          className={classes.input}
          onFocus={onFocus(line, line.quantity)}
          onBlur={onBlur(line)}
          defaultValue={line.quantity}
          style={
            qttHasError
              ? {
                  border: "1px dashed #f00",
                  color: "red",
                }
              : undefined
          }
        />
      </TableCell>
      <TableCell classes={cellClasses} key={line.index + "unit"}>
        <input
          ref={inputsUnitRef}
          id={"input-unit-" + index}
          name={"unit"}
          type="text"
          readOnly={readonly}
          className={classes.input}
          onFocus={onFocus(line, line.unit)}
          onBlur={onBlur(line)}
          defaultValue={line.unit}
        />
      </TableCell>
    </TableRow>
  );
};

@observer
class TakeOffEditFormat extends React.Component<IProps> {
  state = {
    inputOldValue: "",
    searchResults: [],
    searchValue: "",
    searchValueString: "",
    linesWithFormulaError: new Array<number>(),
    linesWithDescError: new Array<number>(),
  };

  private firstInputDescRef: any;

  constructor(props) {
    super(props);
  }

  private setFirstInputRef = (index, inputsRef) => {
    if (index === 0 && inputsRef[0]) {
      this.firstInputDescRef = inputsRef[0];
    }
  };

  private splitField(field: string): string {
    return field.split("[").join("").split("]").join("");
  }

  private normalizeText(text: string): string {
    return text
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  componentDidMount() {
    ModelMapStore.modelMapFormat
      .filter((fmt) => fmt.quantity !== "")
      .forEach((fmt) => {
        this.verifyIfLineHasValidFormula(fmt.index, fmt.quantity);
        this.verifyIfLineHasValidDescription(fmt.index, fmt.description);
      });
  }

  handleInputFocus = (line, value) => (e) => {
    ModelMapStore.selectedFormatLine = { line: line, target: e.target };
    this.setState({ inputOldValue: value });
  };

  handleInputBlur = (line: any) => (e) => {
    let target = e.target;
    if (this.state.inputOldValue !== target.value) {
      this.updateFormatLine(line, target);
    }
  };

  handleSearchChange = (value) => {
    let searchValue = this.normalizeText(value);
    let searchResults = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.data.fields.filter((field) =>
          this.normalizeText(field).includes(searchValue)
        )
      : [];

    this.setState({
      searchValue,
      searchResults,
      searchValueString: value,
    });
  };

  handleClickAddField = (field) => {
    let { target, line } = ModelMapStore.selectedFormatLine
      ? ModelMapStore.selectedFormatLine
      : {
          target: this.firstInputDescRef.current,
          line: ModelMapStore.modelMapFormat[0],
        };

    if (target) {
      target.value = target.value + "[" + field + "]";
      this.updateFormatLine(line, target);
    }
  };

  handleClickSave = async () => {
    gtag("event", "formatar_model_map", {
      formatar_model_map: 0,
    });

    // Valida as formulas de todas as linhas preenchidas
    let allFormulasValid = ModelMapStore.modelMapFormat
      .filter((fmt) => fmt.quantity !== "")
      .every(
        (fmt) =>
          this.verifyIfLineHasValidFormula(fmt.index, fmt.quantity) &&
          this.verifyIfLineHasValidDescription(fmt.index, fmt.description)
      );

    if (!allFormulasValid) {
      TakeOffStore.openSnack = i18n.modelMaps.takeOffLayer.errorSelect;
      return;
    }

    // Muda as categorias do model map e renderiza novamente os dados do takeOff atualizado
    TakeOffStore.clearTakeOffModelMap();

    ModelMapStore.setIsCurrentWbsNeedToBeUpdated();
    TakeOffStore.hasErrorFilter = false;
    await ModelMapStore.saveFormat();
  };

  private updateFormatLine(line: any, target: any) {
    let inputField = target.name;

    if (inputField === "description") {
      line.description = target.value;
      // Altera a cor da celula errada
      this.verifyIfLineHasValidDescription(line.index, target.value);
    } else if (inputField !== "quantity") {
      line[inputField] = target.value;
    } else {
      line.quantity = target.value;

      let variable = this.splitField(target.value);
      let findo = TakeOffStore.takeOffItems.find(
        (item) => item.properties[variable] && item.properties[variable].unit
      );
      let propsVar = findo ? findo.properties[variable] : undefined;

      if (propsVar) {
        line.unit = propsVar.unit;
        this.setState({ inputOldValue: line.unit });
      }

      // Altera a cor da celula errada
      this.verifyIfLineHasValidFormula(line.index, target.value);
    }

    // Atualiza modelMaps
    let format = [...ModelMapStore.modelMapFormat];
    format[line.index] = line;
    ModelMapStore.modelMapFormat = [...format];
  }

  private verifyIfLineHasValidFormula(index: number, quantity: any): boolean {
    let lines: number[] = this.state.linesWithFormulaError;
    let isValid = true;

    if (!ModelMapStore.validateFormula(quantity)) {
      isValid = false;
    } else {
      isValid = this.verifyIfLineHasValidFields(quantity);
    }

    if (isValid) {
      lines = lines.filter((lnIndex) => lnIndex !== index);
    } else {
      if (!lines.includes(index)) lines.push(index);
    }

    this.setState({ linesWithFormulaError: lines });
    return isValid;
  }

  private verifyIfLineHasValidDescription(
    index: number,
    description: any
  ): boolean {
    let lines: number[] = this.state.linesWithDescError;
    let isValid = this.verifyIfLineHasValidFields(description);

    if (isValid) {
      lines = lines.filter((lnIndex) => lnIndex !== index);
    } else {
      if (!lines.includes(index)) lines.push(index);
    }

    this.setState({ linesWithDescError: lines });
    return isValid;
  }

  private verifyIfLineHasValidFields(value: any): boolean {
    const modelMap = TakeOffStore.takeOffModelMap;
    if (modelMap && modelMap.data.fields) {
      const expression = /(\[[^\]]+\])/g;
      const result = String(value)
        .split(expression)
        .filter((item) => item.indexOf("[") !== -1);

      const allFieldsExist = result.every((item) => {
        item = item.replace("[", "").replace("]", "");
        return modelMap.data.fields.includes(item);
      });
      return allFieldsExist;
    }
    return true;
  }

  handleClean = () => {
    this.handleSearchChange("");
  };

  private getListFields(): any[] {
    const { searchValue, searchResults } = this.state;
    if (searchValue.length === 0) {
      if (
        TakeOffStore.takeOffModelMap &&
        TakeOffStore.takeOffModelMap.data.fields
      ) {
        return TakeOffStore.takeOffModelMap.data.fields;
      }
    } else if (searchValue.length > 0) {
      if (searchResults && searchResults.length > 0) {
        return searchResults;
      }
    }
    return [];
  }

  render() {
    const { classes } = this.props;
    const { searchValue, searchResults } = this.state;
    const listFields = this.getListFields();

    return (
      <React.Fragment>
        <div className={classes.editFormatBody}>
          <div className={classes.searchSection}>
            <div className={classes.searchSectionTitle}>
              {" "}
              {i18n.modelMaps.takeOffLayer.addField}{" "}
            </div>
            <div className={classes.searchFormControl}>
              <TextField
                id="standard-bare"
                fullWidth
                onChange={(e) => this.handleSearchChange(e.target.value)}
                value={this.state.searchValueString}
                placeholder={i18n.modelMaps.takeOffLayer.searchField}
                margin="normal"
                className={classes.searchInput}
                InputProps={{
                  style: { paddingRight: 25 },
                }}
              />
              {this.state.searchValueString != "" && (
                <Remove
                  id="remove"
                  className={[classes.icon, classes.iconRemove].join(" ")}
                  onClick={this.handleClean}
                />
              )}
              <Search
                className={[classes.icon, classes.iconSearch].join(" ")}
              />
            </div>
            <div className={classes.searchResultList}>
              {listFields
                .sort((a, b) =>
                  this.normalizeText(a) > this.normalizeText(b) ? 1 : -1
                )
                .map((field) => this.renderField(classes, field))}
              {searchValue.length > 0 && searchResults.length === 0 && (
                <div className={classes.searchNotFound}>
                  <img src={lupa} />
                  <Typography className={classes.searchNotFoundTitle}>
                    {i18n.developments.noResultsFound.title}
                  </Typography>
                  <Typography className={classes.searchNotFoundSubtitle}>
                    {i18n.developments.noResultsFound.subtitle}
                  </Typography>
                </div>
              )}
            </div>
          </div>
          <div className={classes.editFormatHeader}>
            <Typography className={classes.headerTitleItems}>
              {i18n.modelMaps.takeOffLayer.description}
            </Typography>
            <Typography className={classes.headerTitleItems}>
              {i18n.modelMaps.takeOffLayer.quantity}
            </Typography>
            <Typography className={classes.headerTitleItems}>
              {i18n.modelMaps.takeOffLayer.unit}
            </Typography>
          </div>
          <div className={[classes.table, classes.editFormatTable].join(" ")}>
            <Table className={[classes.table, classes.tableFont].join(" ")}>
              <tbody className={classes.tableBody}>
                {ModelMapStore.modelMapFormat.map((line, index) => {
                  const lineLevel = ModelMapStore.getFormatLevel(line);
                  const isStage = ModelMapStore.getIsStage(line);
                  const descHasError =
                    this.state.linesWithDescError.includes(index);
                  const qttHasError =
                    this.state.linesWithFormulaError.includes(index);

                  let selectedRow =
                    ModelMapStore.selectedFormatLine === undefined
                      ? index === 0
                      : ModelMapStore.selectedFormatLine.line.index ===
                        line.index;

                  return (
                    <TakeOffEditFormatRow
                      key={index}
                      index={index}
                      line={line}
                      classes={classes}
                      onFocus={this.handleInputFocus}
                      onBlur={this.handleInputBlur}
                      onChangeInputRef={this.setFirstInputRef}
                      paddingOffiset={lineLevel}
                      readonly={isStage}
                      descHasError={descHasError}
                      qttHasError={qttHasError}
                      isSelected={selectedRow}
                    />
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>

        <div className={classes.editFormatActions}>
          <Button
            variant="contained"
            color="primary"
            className={[classes.button, classes.buttonCancel].join(" ")}
            onClick={() => {
              TakeOffStore.isFormating = false;
            }}
          >
            {i18n.cancel}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={[classes.button, classes.buttonSave].join(" ")}
            onClick={this.handleClickSave}
          >
            {i18n.save}
          </Button>
        </div>
      </React.Fragment>
    );
  }

  private renderField(classes: any, field: string): JSX.Element {
    return (
      <div className={classes.fieldPicker} key={field}>
        {field}
        <IconButton
          aria-label="Add Field"
          className={classes.checkField}
          onClick={() => {
            this.handleClickAddField(field);
          }}
        >
          <Done fontSize="small" />
        </IconButton>
      </div>
    );
  }
}
export default withStyles(styles)(TakeOffEditFormat);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/TakeOffEditFormat.tsx